import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters.js'
import common from './modules/common'
import user from './modules/user'
import family from './modules/family'

import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

// 用户信息
const pluginUser = createPersistedState({
  key: 'user',
  paths: ['user.userInfo'],
  reducer(state) {
    return {
      user: state.user
    }
  }
})

const pluginFamily = createPersistedState({
  key: 'family',
  paths: ['family.elderly', 'family.currentElderly'],
  reducer(state) {
    return {
      family: state.family 
    }
  }
})

const pluginCommon = createPersistedState({
  storage: window.localStorage,
  key: 'common',
  reducer(state){
    return {
      common: state.common 
    }
  }
})

const store = new Vuex.Store({
  plugins: [pluginUser, pluginFamily, pluginCommon],
  modules: {
    // finance,
    // station,
    user,
    family,
    common
  },
  getters
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js